<template>
	<!-- 修改密碼 -->
	<el-dialog :close-on-click-modal="false"  :title="$t('model.get')" :visible.sync="getModel" top="5vh" @close="hide" :width="isphone?'90%':'50%'">
		<!-- 表單内容 -->
		 <!-- <div class="radio">
		    排序：
		    <el-radio-group v-model="reverse">
		      <el-radio :label="true">倒序</el-radio>
		      <el-radio :label="false">正序</el-radio>
		    </el-radio-group>
		  </div> -->
		<div v-loading="loading">
			<el-form :rules="rules" v-if="getModelType==1" :model="form" ref="get_form"  label-width="100px">
				<el-form-item :label="$t('model.yunAccount')" prop="">
					{{info.name}} ( {{info.username}} ) - {{$t('accountList.money')}}: 
					<span class="text_chengse">
						{{info.money==0?$t('accountList.all'):info.money}}
					</span>
				</el-form-item>
			
				<el-form-item :label="$t('accountList.getUser')" prop="user_id">
					<el-select style="width: 70%;"  v-model="form.user_id" size="small" filterable :placeholder="$t('system.select')">
					</el-option>
						<el-option v-for="item in data" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				
				<el-form-item :label="$t('userList.odds')" prop="odds">
					<el-input v-model="form.odds" :placeholder="$t('userList.odds')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
			</el-form>
			
			<el-form :rules="rules" v-if="getModelType==2" :model="form" ref="get_form"  label-width="100px">
				<el-form-item :label="$t('accountList.getUser')" prop="">
					{{info.name}} ( {{info.username}} ) 
					<span class="text_chengse">
						{{info.money==0?$t('accountList.all'):info.money}}
					</span>
				</el-form-item>
				
				
				<el-form-item :label="$t('model.getType')">
					<el-radio-group v-model="form.rand" size="small">
						<el-radio :label="0" border>{{$t('model.getType1')}}</el-radio>
						<el-radio :label="1" border>{{$t('model.getType2')}}</el-radio>
						
					</el-radio-group>
				</el-form-item>
				
				<el-form-item  v-if="form.rand==1":label="$t('model.yunAccount')" prop="account_id">
					<el-select @change="selAccount" style="width: 70%;"  v-model="form.account_id" size="small" filterable :placeholder="$t('system.select')">
					</el-option>
						<el-option v-for="item in data" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item :label="$t('userList.odds')" prop="odds">
					<el-input v-model="form.odds" :placeholder="$t('userList.odds')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
			
				
				
			</el-form>
		</div>
		
		
		  
		
		

		<div slot="footer" class="dialog-footer">
			<el-button @click="hide">{{$t('model.close')}}</el-button>
			<el-button :loading="loading" :disabled="loading" type="primary" @click="submit">{{$t('model.success')}}</el-button>
		</div>
	</el-dialog>
</template>

<script>
	export default {
		props: {
			getModel: {
				type: Boolean,
				default: false
			},
			isphone: {
				type: Boolean,
				default: false
			},
			getModelType: {
				type: Number,
				default: 1//1账号选定，选择用户，2用户选定，选择账号
			},
			getModelTypeId: {
				type: Number,
				default: 0//getModelType==1 账号ID，getModelType==2 用户ID
			}
		},
		data() {
			return {
				loading:true,
				reverse: false,
				info: {name:'',money:0,username:'',odds:0},
				data:[],
				form:{
					user_id:'',
					account_id:'',
					type:1,
					odds:0,
					rand:0,
					type_id:0
				},
				rules: {
					user_id: [{
						required: true,
						message: this.$t('model.selUser'),
						trigger: 'blur',
					}],
					account_id: [{
						required: true,
						message: this.$t('orderList.selAccount'),
						trigger: 'blur',
					}],
					odds: [{
						required: true,
						message: this.$t('userList.odds'),
						trigger: 'blur',
					}]
				},
			}
		},
		watch: {
			getModel(newVal) {
				if(newVal){
						this.form = {
						user_id:'',
						apply_id:0,
						account_id:'',
						rand:0,//1随机
						odds:0,
						type:1,
						type_id:0
					} 
					this.checkGetData()
				}
			},
		},
		methods: {
			hide(){
				this.$emit('hide')
			},		
			changeNum(){
				this.$emit('changeNum')
			},
			submit(){
				this.$refs.get_form.validate(res => {
					
					if (res) {
						this.loading = true
						this.axios.post('/admin/data/getAccountUser', this.form, {
							token: true
						}).then(res => {
							this.loading = false
							let all = res.data
							
							if (all.code == 1) {
								this.changeNum()
								this.hide()
							}
							
						}).catch(err => {
							this.loading = false
						})
					}
				})
				
				
			},
			
			selAccount(e){
				let index = this.data.findIndex(item=>item.id == e)
				if(index!=-1){
					this.form.odds = this.data[index].odds 
				}
			},
			
			checkGetData(){
				
				this.form.type = this.getModelType
				this.form.type_id = this.getModelTypeId
				if(this.getModelType==1){
					this.form.account_id = this.getModelTypeId
				}else{
					this.form.apply_id = this.getModelTypeId
				}
				this.axios.post('/admin/data/checkGetData', this.form, {
					token: true
				}).then(res => {
					let all = res.data
					
					if (all.code == 1) {
						this.loading = false
						console.log(all)
						this.info = all.data.list.info
						this.form.odds = this.info.odds
						
						if(this.getModelType==2){
							this.form.user_id = this.info.id
						}
						this.data = all.data.list.data
						//this.hide()
					}
					
				}).catch(err => {
					
				})
			}
		}
	}
</script>

<style>
	.phone_w{
		width: 90%;;
	}
	.pc_w{
		width: 34%;;
	}
</style>
